'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var styles = require('@material-ui/styles');
var Tabs = require('@material-ui/core/Tabs');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Tabs__default = /*#__PURE__*/_interopDefaultLegacy(Tabs);

var useStyles = styles.makeStyles(theme => ({
  root: {
    minHeight: 56,
    height: '100%'
  },
  flexContainer: {
    display: 'inline-flex',
    position: 'relative',
    zIndex: 1
  },
  scroller: {
    [theme.breakpoints.up('md')]: {
      padding: '0 8px'
    }
  },
  indicator: {
    top: 0,
    bottom: 0,
    right: 0,
    height: 'auto',
    background: 'none',
    '&:after': {
      content: '""',
      display: 'block',
      position: 'absolute',
      boxSizing: 'border-box',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      borderBottom: "3px solid ".concat(theme.palette.primary.main) // borderLeft: `1px solid ${theme.palette.divider}`,
      // borderRight: `1px solid ${theme.palette.divider}`,
      // borderTopLeftRadius: theme.shape.borderRadius,
      // borderTopRightRadius: theme.shape.borderRadius,
      // backgroundColor: theme.palette.mode === 'light' ? '#fff' : theme.palette.action.selected,
      // backgroundColor: theme.palette.grey[50],
      // boxShadow: 'inset 1px 0 2px 0 rgba(0,0,0,0.16), inset -1px 0 2px 0 rgba(0,0,0,0.16)',

    }
  }
}));
var NavTabs = props => {
  var classes = useStyles();
  return /*#__PURE__*/React__namespace.createElement(Tabs__default['default'], _rollupPluginBabelHelpers['extends']({}, props, {
    classes: {
      root: classes.root,
      flexContainer: classes.flexContainer,
      scroller: classes.scroller,
      indicator: classes.indicator
    }
  }));
};

exports.NavTabs = NavTabs;
exports.default = NavTabs;
